import React from "react";

const TechErrorPage = () => {
	return (
		<div className="techErrorWrapper">
			<div class="error-block">
				<h1 class="error">Err: 500</h1>
				<div class="page">Ooops! Failed to fetch Data - server error</div>
				<div class="page">Try after sometimes....</div>
				{/* <a class="back-home" href="#!">
					Back to home
				</a> */}
			</div>
		</div>
	);
};

export default TechErrorPage;
